import {
  GET_ALL_CATEGORY_LIST,
  GET_ALL_CATEGORY_LIST_SUCCESS,
  GET_ALL_CATEGORY_LIST_FAILURE,
} from 'store/getAllCategoryList/action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getAllCategoryListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_CATEGORY_LIST:
      return { ...state, loading: true };
    case GET_ALL_CATEGORY_LIST_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_ALL_CATEGORY_LIST_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getAllCategoryListReducer;
